import { Card, CardContent, CardHeader, Container, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { MobilePDFReader } from 'react-read-pdf';
import Page from 'src/components/Page';
import Pdf from '../../assets/pdf/oasis-kullanim-kilavuzu.pdf';




const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  pdfOuter: {
    position: 'relative',
    height: 600
  }
}));

function Overview() {
  const classes = useStyles();


  return (
    <Page className={classes.root} title="oasis Yönetimi Yardım">
      <style>
        .mobile__pdf__container #viewerContainer .pdfViewer {'{'}overflow:hidden;{'}'}
        .pdfViewer .page {'{'}margin-bottom:50px; border:0;{'}'}
        .mobile__pdf__container #viewerContainer {'{'} top:0;bottom:0;{'}'}

      </style>
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="oasis Yönetimi Yardım" />
          <Divider />
          <CardContent>
            <div className={classes.pdfOuter}>
              <MobilePDFReader isShowFooter={false} isShowHeader={false} url={Pdf} /></div>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}

export default Overview;
